import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {UploadFatturePassiveComponent} from './upload-fatture-passive';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.upload-fatture-passive', {
            url: '/upload-fatture-passive',
            ncyBreadcrumb: {
                label: 'Upload Fatture Passive',
                parent: 'home.admin'
            },
            data: {
                authorisationLevel: 2,
                pageTitle: 'Upload Fatture Passive'
            },
            'views': {
                'homeContent': {
                    template: '<upload-fatture-passive flex="100"></upload-fatture-passive>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const UploadFatturePassiveModule: string = ng
    .module('upload-fatture-passive', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('uploadFatturePassive', UploadFatturePassiveComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/upload-fatture-passive/upload-fatture-passive.module.ts